export default {
  orderCreateWithoutPaymentPath: (_store, _getters) => thisContext => {
    const location = thisContext.localeLocation({
      name: 'business-orderCreateWithoutPayment'
    })
    const resolve = thisContext.$router.resolve(location)
    return resolve.route.path
  }
}
